import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'notification/';

class NotificationService {

    getProfileContacts(baliseId, profileId) {
        return axios.get(API_URL + 'getBaliseContacts/' + UserHelper.getClientId(),
            {
                params: { baliseId: baliseId, profileId: profileId },
                headers: authHeader()
            }
        );
    }

    addContact(baliseId, profileId, contactId) {
        return axios.put(API_URL + 'addBaliseContact/' + UserHelper.getClientId(),
            {
                baliseId: baliseId,
                profileId: profileId,
                contactId: contactId
            },
            { headers: authHeader() });
    }

    removeContact(baliseId, profileId, contactId) {
        return axios.delete(API_URL + 'removeBaliseContact/' + UserHelper.getClientId(),
            {
                data: {
                    baliseId: baliseId,
                    profileId: profileId,
                    contactId: contactId
                },
                headers: authHeader()
            }
        );
    }
}

export default new NotificationService();